<template>
  <div class="location-card v-card">
      <div class="location-card-content v-card-content">
        <img v-if="office.image" :src="office.image" class="office-image" />
        <h3>{{ office.name }}</h3>
        <span v-if="office.street">{{ office.street }}</span>
        <span v-if="office.citystatezip"
          >{{ office.citystatezip }}</span
        >
        <span v-if="office.tel">TEL: {{ office.tel }}</span>
        <span v-if="office.fax">FAX: {{ office.fax }}</span>
        <span v-if="office.email"
          >Email: {{ office.email }}</span
        >
        <span v-if="office.positions" class="v-card-positions">
          <span
            v-for="position in office.positions"
            v-bind:key="position.title"
          >
            <u>{{ position.title }}:</u> {{ position.name }}
          </span>
        </span>
        <span v-if="office.additionalLocations" class="v-card-additional-locations">
          <strong>Additional closing locations:</strong>
          <ul>
            <li
              v-for="location in office.additionalLocations"
              v-bind:key="location.address"
            >
              {{ location.address }}
            </li>
          </ul>
        </span>
      </div>
  </div>
</template>

<style scoped>
.location-card-content {
  font-size: 16px;
  font-family: Source Sans Pro, Arial, Helvetica, sans-serif;
  color: #202a2f;
  text-align: left;
  line-height: 1.25;
}
.location-card {
  max-width: 320px;
  margin: 0 auto 1rem;
  width: 100%;
  height: 100%;
  display: flex;
}

.location-card-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 0.25rem;
  padding: 1rem;
}
.office-image {
  width: 100%;
  height: auto;
  display: block;
  margin-bottom: 0.5rem;
}

li {
  text-align: left;
}

.v-card {
  webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
  background-color: #fff;
}
.v-card-content {
  padding: 16px;
  padding-top:24px;
}

.v-card h3 {
  font-size: 1.17em;
  font-weight: bold;
}

.v-card span {
  font-size: 16px;
  display: block;

  margin: 0;
  padding: 0;
}

.v-card-positions,
.v-card-additional-locations {
  margin-top: 20px !important;
}
</style>

<script setup>
defineProps({
  office: {
    type: Object,
    required: true,
  },
});
</script>
